import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SuccessModalComponent } from './modal/success/success-modal.component';
import { LoadingModalComponent } from './modal/loading/loading-modal.component';
import { ErrorModalComponent } from './modal/error/error-modal.component';
import { Observable, of, timer } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    progressBar: any = { value: 0, show: false };
    private timeInterval;

    constructor(private ngbModal: NgbModal) { }

    public OpenModal(component: any, args?: NgbModalOptions) {

        let options = {
            backdrop: 'static' as 'static'
        };

        options = Object.assign(options, args);

        return this.ngbModal.open(component, options);
    }

    public Success(message: string, args?: NgbModalOptions) {

        let options: NgbModalOptions = {
            backdrop: false,
            windowClass: 'general-success-popup'
        };

        options = Object.assign(options, args);

        let modal = this.ngbModal.open(SuccessModalComponent, options);
        modal.componentInstance.message = message;

        setTimeout(function () {
            modal.dismiss();
        }, 2000);
    }

    public Error(message: string, withCloseBtn?: boolean, args?: NgbModalOptions) {

        let options: NgbModalOptions = {
            backdrop: false
        };

        options = Object.assign(options, args);

        let modal = this.ngbModal.open(ErrorModalComponent, options);
        modal.componentInstance.message = message;
        modal.componentInstance.withCloseBtn = withCloseBtn || false;
    }

    public Loading(args?: NgbModalOptions) {

        let options: NgbModalOptions = {
            backdrop: 'static' as 'static',
            keyboard: false,
            windowClass: 'preloader'
        };

        options = Object.assign(options, args);

        return this.ngbModal.open(LoadingModalComponent, options);        
    }

    ShowProgressBar() {
        this.progressBar.value = 0;
        this.progressBar.show = true;
        this.timeInterval = timer(0, 100)
            .subscribe(() => {
                if (this.progressBar.value < 88) {
                    this.progressBar.value += Math.floor(Math.random() * 10) + 1;
                }
            });
    }

    HideProgressBar() {
        this.progressBar.value = 100;
        timer(1000)
            .subscribe(() => {
                this.timeInterval.unsubscribe();
                this.progressBar.show = false;
            });
    }
}
